import AddressVerificationWrapper from './AddressVerificationWrapper'

export default AddressVerificationWrapper
